module.exports = __webpack_public_path__ + "static/img/5.35915fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/5.jpg
// module id = CkN/
// module chunks = 2